import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMapMarkerAlt,
    faPaw,
    faPhoneAlt,
    faDollarSign,
    faClock,
    faTimes,
    faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

import api from "../../../api/api";
import {
    CURRENCY_CODE,
    DELIVERY_STATUS,

} from "../../../config/constants";

import EditAdditionalInfo from "../../../components/AdditionalInfoEditor";
import DeliveryMapStatus from "./DeliveryStatus";
import Feedback from "./Feedback";

// const POLLING_INTERVAL = 10000; // Polling interval in milliseconds

const DeliveryDetailModal = ({
    delivery: initialDelivery,
    isOpen,
    onClose,
}) => {
    const [delivery, setDelivery] = useState(initialDelivery);
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [shouldFetch, setShouldFetch] = useState(false);




    const getServiceLabel = (key) => {
        switch (key) {
            case "location":
                return "Distance Fee";
            case "pet":
                return "Additional Pet Fee";
            case "want_cage":
                return "Pet Cage Fee";
            case "two_way":
                return "Two-Way Trip Fee";
            default:
                return key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
        }
    };

    const canEditAdditionalDetail = () => {
        if (
            delivery.status == DELIVERY_STATUS.REQUESTED ||
            delivery.status == DELIVERY_STATUS.FINDING
        ) {
            return true;
        }
        return false;
    };

    // useEffect(() => {
    //     const timeoutId = setTimeout(() => {
    //         if (delivery && delivery.pickup_location) {
    //             setSortMapData((prev) => ({
    //                 ...prev,
    //                 pickup_latitude: delivery.pickup_location.latitude,
    //                 pickup_longitude: delivery.pickup_location.longitude,
    //                 pickup_address: delivery.pickup_location.address,
    //             }));
    //         }

    //         if (delivery && delivery.dropoff_location) {
    //             setSortMapData((prev) => ({
    //                 ...prev,
    //                 dropoff_latitude: delivery.dropoff_location.latitude,
    //                 dropoff_longitude: delivery.dropoff_location.longitude,
    //                 dropoff_address: delivery.dropoff_location.address,
    //             }));
    //         }

    //         if (delivery && delivery.pickup_location && delivery.dropoff_location) {
    //             calculateRoute(delivery);
    //         }
    //     }, 1000); // 1 second delay

    //     // Clear timeout if the component unmounts before 1 second
    //     return () => clearTimeout(timeoutId);
    // }, []);

    //   useEffect(() => {

    // if (initialDelivery?.id) {
    // Start polling
    //   const intervalId = setInterval(() => {
    // fetchDeliveryDetail(initialDelivery.id);
    //   }, POLLING_INTERVAL);

    //   return () => clearInterval(intervalId); // Cleanup interval on component unmount
    // }

    //   }, [initialDelivery]);

    // const fetchDeliveryDetail = async (id) => {
    //     try {
    //         const response = await api.get(`/deliveries/${id}`);
    //         const updatedDelivery = response.data;
    //         setDelivery(updatedDelivery);

    //         // If the status or location has changed, recalculate the route
    //         if (
    //             updatedDelivery.status !== delivery.status ||
    //             updatedDelivery.pickup_location.latitude !==
    //             delivery.pickup_location.latitude ||
    //             updatedDelivery.dropoff_location.latitude !==
    //             delivery.dropoff_location.latitude
    //         ) {
    //             calculateRoute(updatedDelivery);
    //         }
    //     } catch (error) {
    //         toast.error("Failed to update delivery details.");
    //     }
    // };

    const calculateRoute = (deliveryData) => {
        if (
            !deliveryData.pickup_location.latitude ||
            !deliveryData.dropoff_location.latitude
        )
            return;

        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: {
                    lat: deliveryData.pickup_location.latitude,
                    lng: deliveryData.pickup_location.longitude,
                },
                destination: {
                    lat: deliveryData.dropoff_location.latitude,
                    lng: deliveryData.dropoff_location.longitude,
                },
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirectionsResponse(result);
                } else {
                    // Error fetching directions
                }
            }
        );
    };

    const handleAdditionalInfoSave = (shouldFetchDeliveries = false) => {
        setShouldFetch(shouldFetchDeliveries);
    };


    return (
        <Transition appear show={isOpen} as={Fragment}>
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />

            <Dialog
                as="div"
                className="relative z-50"
                onClose={() => onClose(shouldFetch)}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-sm sm:max-w-2xl lg:max-w-4xl xl:max-w-7xl transform overflow-hidden rounded-xl sm:rounded-2xl bg-white p-3 sm:p-4 lg:p-6 text-left align-middle shadow-xl transition-all max-h-[90vh] overflow-y-auto">
                                <Dialog.Title
                                    as="h3"
                                    className="text-xl sm:text-2xl lg:text-3xl font-bold text-primary mb-3 sm:mb-4"
                                >
                                    Delivery Details
                                </Dialog.Title>

                                {/* Close Button */}
                                <button
                                    type="button"
                                    className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 p-1"
                                    onClick={onClose}
                                >
                                    <FontAwesomeIcon icon={faTimes} className="h-5 w-5 sm:h-6 sm:w-6" />
                                </button>

                                {/* Map */}
                                <DeliveryMapStatus delivery={delivery} />

                                {delivery.status === DELIVERY_STATUS.COMPLETED && delivery.feedback == null && (
                                    <Feedback item={delivery} type={'delivery'} />
                                )}

                                {delivery.driver && (
                                    <div className="flex items-center p-4 rounded-lg bg-gray-50 shadow-md mb-6">
                                        <img
                                            src={delivery.driver.profile_photo}
                                            alt={delivery.driver.name}
                                            className="w-16 h-16 rounded-full object-cover shadow-sm"
                                        />
                                        <div className="ml-4 text-gray-700 space-y-1">
                                            <h4 className="text-lg font-semibold">{delivery.driver.name}</h4>
                                            <p>
                                                <FontAwesomeIcon
                                                    icon={faPhoneAlt}
                                                    className="mr-2 text-purple-500"
                                                />
                                                {delivery.driver.phone || "N/A"}
                                            </p>
                                            <p>
                                                <FontAwesomeIcon
                                                    icon={faInfoCircle}
                                                    className="mr-2 text-purple-500"
                                                />
                                                {delivery.driver.email || "N/A"}
                                            </p>
                                        </div>
                                    </div>
                                )}
                                {/* Locations */}
                                <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6">
                                    <h2 className="text-xl font-semibold mb-4">
                                        Location Information
                                    </h2>
                                    <div className="flex items-center mb-4">
                                        <FontAwesomeIcon
                                            icon={faMapMarkerAlt}
                                            className="text-purple-600 mr-2"
                                        />
                                        <span>
                                            <strong>Pickup Location:</strong>{" "}
                                            {delivery.pickup_location?.address || "N/A"}
                                        </span>
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <FontAwesomeIcon
                                            icon={faMapMarkerAlt}
                                            className="text-pink-600 mr-2"
                                        />
                                        <span>
                                            <strong>Dropoff Location:</strong>{" "}
                                            {delivery.dropoff_location?.address || "N/A"}
                                        </span>
                                    </div>
                                    <div className="flex items-center mb-4">
                                        <FontAwesomeIcon
                                            icon={faClock}
                                            className="text-gray-600 mr-2"
                                        />
                                        <span>
                                            <strong>Duration:</strong>{" "}
                                            {delivery.google?.duration || "N/A"}
                                        </span>
                                    </div>
                                    <div className="flex items-center">
                                        <FontAwesomeIcon
                                            icon={faDollarSign}
                                            className="text-green-600 mr-2"
                                        />
                                        <span>
                                            <strong>Estimated Distance:</strong>{" "}
                                            {delivery.google?.distance || "N/A"}
                                        </span>
                                    </div>
                                </div>



                                {/* Total */}
                                <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6 ">
                                    <h2 className="text-xl font-semibold mb-4">Cost Breakdown</h2>

                                    <div className="">
                                        {/* Charges Breakdown */}
                                        <div className="mb-4">
                                            <h4 className="text-lg font-semibold text-gray-700 mb-3">
                                                Service Charges
                                            </h4>
                                            <div className="space-y-2">
                                                {/* Loop through delivery.charges */}
                                                {Object.keys(delivery.charges).map((key, index) =>
                                                    key !== "base_rate" &&
                                                        key !== "total" &&
                                                        key !== "discount_amount" &&
                                                        parseFloat(delivery.charges[key]) > 0 ? (
                                                        <div
                                                            key={index}
                                                            className="flex items-center justify-between"
                                                        >
                                                            <span className="text-gray-600 flex items-center">
                                                                <FontAwesomeIcon
                                                                    icon={faPaw}
                                                                    className="text-yellow-500 mr-2"
                                                                />
                                                                {getServiceLabel(key)}:
                                                            </span>
                                                            <span className="text-gray-800">
                                                                <strong>
                                                                    {parseFloat(delivery.charges[key]).toFixed(2)}{" "}
                                                                    {CURRENCY_CODE}
                                                                </strong>
                                                            </span>
                                                        </div>
                                                    ) : null
                                                )}
                                            </div>
                                        </div>

                                        {/* Base Rate */}
                                        <div className="flex items-center justify-between pt-2 border-t">
                                            <span className="text-gray-600 flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faPaw}
                                                    className="text-tblue mr-2"
                                                />
                                                Base Rate:
                                            </span>
                                            <span className="text-gray-800">
                                                <strong>
                                                    +{parseFloat(delivery.charges.base_rate).toFixed(2)}{" "}
                                                    {CURRENCY_CODE}
                                                </strong>
                                            </span>
                                        </div>

                                        {/* Original Total (before discount, including Base Rate) */}
                                        <div className="flex items-center justify-between border-t pt-3 mt-3">
                                            <span className="text-gray-600 flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faPaw}
                                                    className="text-gray-500 mr-2"
                                                />
                                                Original Total (Including Base Rate):
                                            </span>
                                            <span className="text-gray-800">
                                                <strong>
                                                    {(
                                                        parseFloat(delivery.charges.total) +
                                                        parseFloat(delivery.charges.discount_amount)
                                                    ).toFixed(2)}{" "}
                                                    {CURRENCY_CODE}
                                                </strong>
                                            </span>
                                        </div>

                                        {/* Discount Section */}
                                        {parseFloat(delivery.charges.discount_amount) > 0 && (
                                            <div className="flex items-center justify-between mt-2 text-green-600">
                                                <span className="flex items-center">
                                                    <FontAwesomeIcon
                                                        icon={faPaw}
                                                        className="text-green-500 mr-2"
                                                    />
                                                    Discount Applied:
                                                </span>
                                                <strong>
                                                    -
                                                    {parseFloat(delivery.charges.discount_amount).toFixed(
                                                        2
                                                    )}{" "}
                                                    {CURRENCY_CODE}
                                                </strong>
                                            </div>
                                        )}

                                        {/* Final Total */}
                                        <div className="flex items-center justify-between mt-4 text-lg font-bold border-t pt-3">
                                            <span className="text-purple-600 flex items-center">
                                                <FontAwesomeIcon icon={faPaw} className="mr-2" />
                                                Total{" "}
                                                {parseFloat(delivery.charges.discount_amount) > 0
                                                    ? "(After Discount)"
                                                    : null}
                                                :
                                            </span>
                                            <span className="text-gray-800">
                                                <strong>
                                                    {parseFloat(delivery.charges.total).toFixed(2)}{" "}
                                                    {CURRENCY_CODE}
                                                </strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Pets */}
                                <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6">
                                    <h2 className="text-xl font-semibold mb-4">Selected Pets</h2>
                                    <div className="grid grid-cols-2 gap-4">
                                        {delivery.pets &&
                                            delivery.pets.length > 0 &&
                                            delivery.pets.map((pet) => (
                                                <div
                                                    key={pet.id}
                                                    className="flex items-center bg-white p-3 rounded-lg shadow-sm"
                                                >
                                                    <img
                                                        src={pet.primary_image_url}
                                                        alt={pet.name}
                                                        className="w-12 h-12 rounded-full object-cover mr-4"
                                                    />
                                                    <div>
                                                        <p className="font-semibold">{pet.name}</p>
                                                        <p className="text-gray-500 text-sm">{pet.breed}</p>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>

                                {/* Additional Options */}
                                <div className="bg-gray-100 p-4 rounded-lg shadow-md mb-6">
                                    <h2 className="text-xl font-semibold mb-4">
                                        Additional Options
                                    </h2>
                                    <div className="flex items-center mb-4">
                                        <FontAwesomeIcon
                                            icon={faPaw}
                                            className="text-primary mr-2"
                                        />
                                        <span>
                                            <strong>Want Cage:</strong>{" "}
                                            {delivery.want_cage ? "Yes" : "No"}
                                        </span>
                                    </div>
                                    <div className="flex items-center">
                                        <FontAwesomeIcon
                                            icon={faPhoneAlt}
                                            className="text-blue-600 mr-2"
                                        />
                                        <span>
                                            <strong>Emergency Contact:</strong>{" "}
                                            {delivery.emergency_no || "N/A"}
                                        </span>
                                    </div>
                                </div>

                                <EditAdditionalInfo
                                    item={delivery}
                                    type="deliveries"
                                    onSave={handleAdditionalInfoSave}
                                    canEdit={canEditAdditionalDetail}
                                />

                                {/* Actions */}
                                {/* <div className="flex space-x-4 mt-4">
                                    <button
                                        onClick={handleCancelDelivery}
                                        className="bg-red-500 text-white px-4 py-2 rounded-lg flex items-center hover:bg-red-600"
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                                        Cancel Delivery
                                    </button>
                                    <button
                                        className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center hover:bg-blue-600"
                                        onClick={() => {
                                            // Handle edit logic here (redirect to edit page or open modal)
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEdit} className="mr-2" />
                                        Edit Delivery
                                    </button>
                                </div> */}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default DeliveryDetailModal;
